module.exports = function() {
  return new Worker(__webpack_public_path__ + "e3b4e6123ad5c2340660.worker.js");
};